module.exports = __webpack_public_path__ + "static/img/14.9086c381.jpeg";